"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChangePaymentAmount = void 0;
var kapi_1 = require("../../../shared/api/kapi");
var change_payment_schedule_1 = require("../../../shared/api/kapi/v1/operations/payments/__generated__/change-payment-schedule");
var legacy_queries_1 = require("../../../shared/api/legacy-queries");
var utils_1 = require("../../../shared/api/utils");
var core_1 = require("../../../shared/core");
var useChangePaymentAmount = function (_a) {
    var customerId = _a.customerId, accountId = _a.accountId;
    var region = core_1.configService.getConfig().retailer.region;
    var useKapi = region === 'AUS';
    var _b = __read((0, change_payment_schedule_1.useChangePaymentScheduleMutation)(), 2), kapiMutation = _b[0], loading = _b[1].loading;
    var updateCache = (0, utils_1.useUpdateCache)({
        document: kapi_1.PaymentDetailsDocument,
        variables: { accountId: accountId },
    }).updateCache;
    var handleKapiMutation = function (body, _a) {
        var _b;
        var _c = _a === void 0 ? {} : _a, onCompleted = _c.onCompleted, onError = _c.onError;
        kapiMutation({
            variables: {
                input: {
                    customerId: customerId,
                    paymentScheduleId: (_b = body.paymentScheduleId) !== null && _b !== void 0 ? _b : '',
                    amount: {
                        value: body.amount.value,
                        currency: body.amount.currency,
                    },
                },
            },
            onCompleted: function (data) {
                updateCache({
                    account: {
                        paymentSchedule: {
                            id: data.changePaymentSchedule.id,
                            amount: {
                                value: body.amount.value,
                            },
                        },
                    },
                });
                onCompleted &&
                    onCompleted({
                        newAmount: {
                            amount: body.amount.value,
                            currencyUnit: body.amount.currency,
                        },
                    });
            },
            onError: onError,
        });
    };
    var legacyMutation = (0, legacy_queries_1.useDirectDebitAmountLegacyMutation)(accountId);
    var handleLegacyMutation = function (body, _a) {
        var _b = _a === void 0 ? {} : _a, onCompleted = _b.onCompleted, onError = _b.onError;
        if (legacyMutation.status !== 'in-progress') {
            legacyMutation.mutate({ amount: Number(body.amount.value) }, {
                onError: function (error) { return onError && onError(error); },
                onSuccess: onCompleted,
            });
        }
    };
    return {
        mutate: useKapi ? handleKapiMutation : handleLegacyMutation,
        loading: useKapi ? loading : legacyMutation.status === 'in-progress',
    };
};
exports.useChangePaymentAmount = useChangePaymentAmount;
